/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Sort_Direction_AscendingInputs */

const en_enum_sort_direction_ascending = /** @type {(inputs: Enum_Sort_Direction_AscendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direction Ascending`)
};

const de_enum_sort_direction_ascending = /** @type {(inputs: Enum_Sort_Direction_AscendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direction Ascending`)
};

/**
* | output |
* | --- |
* | "Direction Ascending" |
*
* @param {Enum_Sort_Direction_AscendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_sort_direction_ascending = /** @type {((inputs?: Enum_Sort_Direction_AscendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Sort_Direction_AscendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sort_direction_ascending(inputs)
	return de_enum_sort_direction_ascending(inputs)
});